/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_ConnectedInputs */

const vi_station_connected = /** @type {(inputs: Station_ConnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã kết nối`)
};

/**

* @param {Station_ConnectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_connected = /** @type {((inputs?: Station_ConnectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_ConnectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_connected(inputs)
});